import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">

      {/* ===== CENTERED FOOTER CONTENT ===== */}
      <div className="footer-inner">

        {/* TOP GRID */}
        <div className="footer-container">

          {/* Company Profile */}
          <div className="footer-column">
            <h3>Company Profile</h3>
            <ul>
              <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
              <li><Link to="/contact" onClick={handleLinkClick}>Contact Us</Link></li>
              <li><Link to="/about" onClick={handleLinkClick}>About Us</Link></li>
              <li><Link to="/housekeeping" onClick={handleLinkClick}>Housekeeping Services</Link></li>
              <li><Link to="/corporate-eventcleaning" onClick={handleLinkClick}>Floor, Carpet & Upholstery Solutions</Link></li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="footer-column">
            <h3>Our Services</h3>
            <ul>
              <li><Link to="/housekeeping" onClick={handleLinkClick}>Housekeeping Services </Link></li>
              <li><Link to="/corporate-IndustrialWarehouseCleaning" onClick={handleLinkClick}>Industrial Cleaning & Warehouse Service</Link></li>

              <li><Link to="/corporate-pantryservices" onClick={handleLinkClick}>Pantry & Cafeteria Support Services </Link></li>

            </ul>
          </div>

          {/* Extra Services */}
          <div className="footer-column">
            <h3>Others Link</h3>
            <ul>

              <li><Link to="/corporate-FacadeExternalCleaning" onClick={handleLinkClick}>Facade & High-Rise Exterior Cleaning</Link></li>
              <li><Link to="/corporate-EngineeringTechnical" onClick={handleLinkClick}>Engineering & Technical Maintenance Service</Link></li>
              <li><Link to="/corporate-deepcleaning" onClick={handleLinkClick}>Deep Cleaning Services</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="footer-column">
            <h3>Contact Us</h3>
            <div className="footer-contact">
              <p><FaPhoneAlt /> +91-9899811123</p>
              <p><FaPhoneAlt /> +91-9971118390</p>
              <p><FaEnvelope /> infodel@densat.com</p>
            </div>
          </div>

        </div>

        {/* SOCIAL ICONS */}
        <div className="footer-social-center">
          <a
            href="https://www.facebook.com/DensatFacilityManagement/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>

          <a
            href="https://x.com/Densat_Services"
            target="_blank"
            rel="noreferrer"
            aria-label="Twitter / X"
          >
            <FaTwitter />
          </a>

          <a
            href="https://www.linkedin.com/company/densat-management/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.instagram.com/2020densat/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </div>

      </div>

      {/* COPYRIGHT BAR */}
      <div className="footer-bottom">
        COPYRIGHT © DENSAT
      </div>

    </footer>
  );
};

export default Footer;
